import { createApp } from "vue";
import AppWrapper from "./AppWrapper.vue";

import * as Sentry from "@sentry/browser";
import { BrowserTracing } from "@sentry/tracing";

import "./css-reset.css";
import "./global.css";
import { visible } from "@fresh8/vue-utils/src/directives/visible";
import { adtag } from "./prefetch";
import { F8LoadingError } from "./lib/loading";

Promise.allSettled([adtag()]).then(([adTag]) => {
  // Create a random seed to determin if we should collect errors for Sentry
  const randomInt32Seed = Math.abs(
    crypto.getRandomValues(new Uint32Array(1))[0]
  );

  if (randomInt32Seed < 1_000_000) {
    Sentry.init({
      dsn:
        "https://68ebf608eb6f4777b265a5b0d5404b6b@o106904.ingest.sentry.io/5557747",
      environment: process.env.NODE_ENV,
      whitelistUrls: [/https?:\/\/(.)*\.fresh8.co/],
      integrations: [new BrowserTracing()]
    });
  }

  if (adTag.status === "rejected") {
    F8LoadingError();

    // throw error for sentry??
  } else {
    const App = createApp(AppWrapper, { adTag: adTag.value });

    App.config.errorHandler = function(err) {
      Sentry.captureException(err);
      //eslint-disable-next-line no-console
      console.error(err);
    };

    App.directive("visible", visible);

    App.mount("#app");
  }
});
